import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createSiteFailed,
  createSiteRequested,
  createSiteSucceeded,
  deleteSiteFailed,
  deleteSiteRequested,
  deleteSiteSucceeded,
  fetchSiteFailed,
  fetchSiteRequested,
  fetchSiteSucceeded,
  updateSiteFailed,
  updateSiteRequested,
  updateSiteSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createSiteRequest(factoryId, localId, data) {
  yield put(
    createSiteRequested(localId, {
      ...data,
      factoryId,
    }),
  );

  try {
    const {
      item,
      included: { lines, labels },
    } = yield call(request, api.createSite, factoryId, data);

    const action = createSiteSucceeded(localId, item, lines, labels);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createSiteFailed(localId, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* fetchSiteRequest(id) {
  yield put(fetchSiteRequested(id));

  try {
    const {
      item,
      included: { labels, lines, devices, deviceMemberships, deviceLabels, alarms, attachments },
    } = yield call(request, api.getSite, id);

    const action = fetchSiteSucceeded(
      item,
      labels,
      lines,
      devices,
      deviceMemberships,
      deviceLabels,
      alarms,
      attachments,
    );
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchSiteFailed(id, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateSiteRequest(id, data) {
  yield put(updateSiteRequested(id, data));

  try {
    const { item } = yield call(request, api.updateSite, id, data);

    const action = updateSiteSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateSiteFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteSiteRequest(id) {
  yield put(deleteSiteRequested(id));

  try {
    const { item } = yield call(request, api.deleteSite, id);

    const action = deleteSiteSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteSiteFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
